import { jsx as g } from "@emotion/react/jsx-runtime";
import e from "prop-types";
import { BREAKPOINTS as a } from "../../constants.mjs";
import c from "./Bleed.mjs";
import { css as i } from "@emotion/react";
const h = (n, m) => {
  let s = null, t = null;
  if (typeof n == "object") {
    const { small: l = 2, medium: r = 6, large: o = 12 } = n;
    s = {
      small: l > 2 ? 2 : l < 1 ? 1 : l,
      medium: r > 6 ? 6 : r < 1 ? 1 : r,
      large: o > 12 ? 12 : o < 1 ? 1 : o
    };
  } else {
    const l = n > 12 ? 12 : n < 1 ? 1 : n;
    s = {
      small: Math.round(2 * l / 12) || 1,
      medium: Math.round(6 * l / 12) || 1,
      large: l
    };
  }
  if (typeof m == "object") {
    const { small: l, medium: r, large: o } = m;
    t = {
      small: l > 2 ? 2 : l < 0 ? 0 : l,
      medium: r > 6 ? 6 : r < 0 ? 0 : r,
      large: o > 12 ? 12 : o < 0 ? 0 : o
    };
  } else if (m) {
    const l = m > 12 ? 12 : m < 0 ? 0 : m, r = Math.floor(2 * l / 12), o = Math.floor(6 * l / 12);
    t = {
      small: r < 1 ? 1 : r,
      medium: o < 1 ? 1 : o,
      large: l
    };
  } else
    t = {
      small: null,
      medium: null,
      large: null
    };
  return {
    sizes: s,
    columnStarts: t
  };
}, $ = (n) => {
  const m = typeof n == "object" ? {
    small: null,
    medium: null,
    large: null,
    ...n
  } : {
    small: n,
    medium: n,
    large: n
  };
  return [
    m.small && i`
                @media (max-width: ${a.MEDIUM}rem) {
                    grid-row: ${m.small};
                }
            `,
    m.medium && i`
                @media (min-width: ${a.MEDIUM}rem) and (max-width: ${a.LARGE}rem) {
                    grid-row: ${m.medium};
                }
            `,
    m.large && i`
                @media (min-width: ${a.LARGE}rem) {
                    grid-row: ${m.large};
                }
            `
  ].filter(Boolean);
}, y = (n, m) => [
  i`
            grid-column-end: span ${n.small};

            @media (min-width: ${a.MEDIUM}rem) {
                grid-column-end: span ${n.medium};
            }
            @media (min-width: ${a.LARGE}rem) {
                grid-column-end: span ${n.large};
            }
        `,
  m.small && i`
                @media (max-width: ${a.MEDIUM}rem) {
                    grid-column-start: ${m.small};
                }
            `,
  m.medium && i`
                @media (min-width: ${a.MEDIUM}rem) and (max-width: ${a.LARGE}rem) {
                    grid-column-start: ${m.medium};
                }
            `,
  m.large && i`
                @media (min-width: ${a.LARGE}rem) {
                    grid-column-start: ${m.large};
                }
            `
], M = "div", p = ({
  size: n = 1,
  columnStart: m,
  gridRow: s,
  component: t,
  bleedLeft: l,
  bleedRight: r,
  ...o
}) => {
  const { sizes: f, columnStarts: b } = h(n, m), d = [...y(f, b), ...$(s)], u = t || M;
  return l || r ? /* @__PURE__ */ g(c, { component: u, ...o, css: d, left: l, right: r }) : /* @__PURE__ */ g(u, { ...o, css: d });
};
p.propTypes = {
  /** Component type used to render the column */
  component: e.oneOfType([e.string, e.element]),
  /** Column start either for all screen widths or for a specific breakpoint.
   * If the columnStart is specified for all screen widths, the value is normalized to match
   * each breakpoint (maximum 2 for small, 6 for medium, 12 for large). */
  columnStart: e.oneOfType([
    e.number,
    e.shape({
      small: e.number,
      medium: e.number,
      large: e.number
    })
  ]),
  /** Grid row style for all screen widths or for a specific breakpoint.
   * Supports a number or native grid-row css values. */
  gridRow: e.oneOfType([
    e.string,
    e.number,
    e.shape({
      small: e.oneOfType([e.string, e.number]),
      medium: e.oneOfType([e.string, e.number]),
      large: e.oneOfType([e.string, e.number])
    })
  ]),
  /** Enable left side bleed over the grid padding, for all screen widths,
   * or specific for small, medium or large */
  bleedLeft: e.oneOfType([
    e.bool,
    e.shape({
      small: e.bool,
      medium: e.bool,
      large: e.bool
    })
  ]),
  /** Enable right side bleed over the grid padding, for all screen widths,
   * or specific for small, medium or large */
  bleedRight: e.oneOfType([
    e.bool,
    e.shape({
      small: e.bool,
      medium: e.bool,
      large: e.bool
    })
  ]),
  /** Column width for all screen widths, or specific for small, medium or large.
   * If the size is specified for all screen widths, the value is normalized to match
   * each breakpoint (maximum 2 for small, 6 for medium, 12 for large) */
  size: e.oneOfType([
    e.number,
    e.shape({
      small: e.number,
      medium: e.number,
      large: e.number
    })
  ])
};
const x = p;
export {
  x as default
};
